import { selectBlotterState } from '../selectors';
import State from 'store/State';
import { useSelector } from 'react-redux';
import {
    BlotterConfiguration,
    initialBlotterConfiguration,
} from './BlotterConfiguration';
import ColumnPortfolio, {
    isValidColumn,
    sanitizeColumns,
    useColumnPortfolio,
} from 'widgets/blotter/columns/ColumnPortfolio';
import { isColumnFilter } from 'widgets/store/grid/filters/FilterState';
import { useEffect, useState } from 'react';

const selectConfig = (state: State, blotterId: string) => {
    const blotterState = selectBlotterState(state, blotterId);
    return blotterState && blotterState.config
        ? blotterState.config
        : initialBlotterConfiguration;
};

export const sanitiseBlotterConfiguration = (
    config: BlotterConfiguration,
    columnPortfolio: ColumnPortfolio
) => {
    const ret = { ...config };
    ret.visibleColumns = sanitizeColumns(
        columnPortfolio,
        config.visibleColumns
    );
    ret.filters = config.filters.filter(
        (f) => !isColumnFilter(f) || isValidColumn(columnPortfolio, f.column)
    );
    ret.sort = config.sort.filter((s) =>
        isValidColumn(columnPortfolio, s.colId)
    );
    return ret;
};

export const selectBlotterConfiguration = (
    state: State,
    blotterId: string,
    columnPortfolio: ColumnPortfolio
) => {
    const config = selectConfig(state, blotterId);
    return sanitiseBlotterConfiguration(config, columnPortfolio);
};

export const useBlotterConfigurationSelector = (blotterId: string) => {
    const columnPortfolio = useColumnPortfolio();
    const config = useSelector((state: State) =>
        selectConfig(state, blotterId)
    );

    const [sanitisedConfig, setSanitizedConfig] =
        useState<BlotterConfiguration>(initialBlotterConfiguration);

    useEffect(() => {
        const nextSanitizedConfig = sanitiseBlotterConfiguration(
            config,
            columnPortfolio
        );
        setSanitizedConfig(nextSanitizedConfig);
    }, [config, columnPortfolio]);

    return sanitisedConfig;
};
